import * as Yup from 'yup';

export const AddProductSchema = Yup.object().shape({
  category: Yup.string().required('Product Category is required'),
  item: Yup.string().required('Product Item is required')
});
